// extracted by mini-css-extract-plugin
export var container = "_4m-0";
export var icon = "_4m-1";
export var text = "_4m-2";